import { useState } from "react";

import { notification } from "antd";

import { ExaminationsApi } from "@/api";
import { ERROR_500_MESSAGE } from "@/api/constants";

const useDeleteExamination = () => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async (examId: number) => {
    try {
      setLoading(true);
      await ExaminationsApi.deleteExamination(examId);
    } catch (e: any) {
      notification.open({
        type: "error",
        message: e.response?.data?.message || ERROR_500_MESSAGE,
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    handleDelete,
  };
};

export default useDeleteExamination;
